angular.module('unica_transfer.transfer_services')

.factory('TransferListService', function($http, getBaseApiURL) {

	var transferListService = {};

	transferListService.list = function (limit, offset) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/transfer/list',
			data: {
				limit: limit,
				offset: offset,
			}
		}).then(function(result) {

			if ( result ) {
				return result.data.transfers;
			}

		});

	};

	transferListService.fullList = function () {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/transfer/full-list',
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.transfers;
			}

		});
	};

	transferListService.get = function (transferId) {
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/transfer/detail/' + transferId,
			data: { }
		}).then(function(result) {

			if ( result ) {
				return result.data.transfer;
			}

		});

	};

	return transferListService;

})
;